import * as React from "react";

export const SvgSuccessOutline = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9.998.4C4.705.4.398 4.707.398 10c0 5.293 4.307 9.6 9.6 9.6 5.294 0 9.6-4.307 9.6-9.6 0-5.293-4.306-9.6-9.6-9.6Zm0 17.455c-4.33 0-7.854-3.524-7.854-7.855s3.523-7.855 7.854-7.855c4.332 0 7.855 3.524 7.855 7.855s-3.524 7.855-7.855 7.855Z"
			fill="#D6D6D6"
		/>
		<path
			d="m13.6 6.607-4.937 4.937L6.4 9.28a.873.873 0 0 0-1.234 1.234l2.88 2.88a.873.873 0 0 0 1.234 0l5.554-5.554A.873.873 0 0 0 13.6 6.607Z"
			fill="#D6D6D6"
		/>
	</svg>
);
